import { isGroupCalendarRoute } from './groupCalendarRouteHandler';
import getAddCalendarState from 'owa-calendar-addcalendar/lib/selectors/getAddCalendarState';
import { lazyHasSelectedProject, lazyGetSelectedProjectId } from 'owa-calendar-board';
import { lazyIsBoardEditorOpen } from 'owa-calendar-board-editor';
import { getCalendarRoutePath, isBoardViewTypeSelected } from 'owa-calendar-module-store';
import readingPaneStore from 'owa-calendar-reading-pane-store/lib/store/store';
import { getCurrentOptionRoute } from 'owa-options-router';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    GROUP_CALENDAR_ROUTE_KEYWORD,
    VIEW_ROUTE_KEYWORD,
    ITEM_ROUTE_KEYWORD,
    ACCOUNT_ROUTE_KEYWORD,
    ADD_CALENDAR_ROUTE_KEYWORD,
    TEAMSNAP_ROUTE_KEYWORD,
    SCHOOLS_ROUTE_KEYWORD,
    PERSONAL_ACCOUNT_ROUTE_KEYWORD,
    BOARD_VIEW_ROUTE_KEYWORD,
    ID_ROUTE_KEYWORD,
    NEW_ROUTE_KEYWORD,
} from '../constants';

export default function getCurrentRoute(): string[] {
    const route: string[] = [];
    const addCalendarState = getAddCalendarState();

    if (
        readingPaneStore.viewState?.itemId &&
        (readingPaneStore.viewState.showModal || readingPaneStore.viewState.isInPopoutWindow)
    ) {
        readingPaneStore.viewState.account
            ? route.push(
                  ACCOUNT_ROUTE_KEYWORD,
                  readingPaneStore.viewState.account,
                  ITEM_ROUTE_KEYWORD,
                  readingPaneStore.viewState.itemId
              )
            : route.push(ITEM_ROUTE_KEYWORD, readingPaneStore.viewState.itemId);
        return route;
    }

    const optionRoute = getCurrentOptionRoute();

    if (optionRoute.length) {
        route.push(...optionRoute);
        return route;
    }

    if (addCalendarState.addCalendarPanelVisible) {
        addCalendarState.teamSnapPanelVisible
            ? route.push(ADD_CALENDAR_ROUTE_KEYWORD, TEAMSNAP_ROUTE_KEYWORD)
            : addCalendarState.schoolsPaneVisible
            ? route.push(ADD_CALENDAR_ROUTE_KEYWORD, SCHOOLS_ROUTE_KEYWORD)
            : addCalendarState.personalAccountPaneVisible
            ? route.push(ADD_CALENDAR_ROUTE_KEYWORD, PERSONAL_ACCOUNT_ROUTE_KEYWORD)
            : route.push(ADD_CALENDAR_ROUTE_KEYWORD);

        return route;
    }

    const {
        isGroupCalendarRoute: isGroupCalendarPage,
        routeInfo: groupCalendarRouteInfo,
    } = isGroupCalendarRoute();

    const routePath = getCalendarRoutePath();

    if (isGroupCalendarPage) {
        const { groupDomain, groupAlias } = groupCalendarRouteInfo;

        route.push(
            GROUP_CALENDAR_ROUTE_KEYWORD,
            groupDomain,
            groupAlias,
            VIEW_ROUTE_KEYWORD,
            routePath
        );

        return route;
    }

    if (
        isFeatureEnabled('cal-board-multipleBoards-dev') &&
        lazyIsBoardEditorOpen.tryImportForRender()?.()
    ) {
        route.push(BOARD_VIEW_ROUTE_KEYWORD, NEW_ROUTE_KEYWORD);
        return route;
    }

    // Update the default calendar routes
    route.push(VIEW_ROUTE_KEYWORD, routePath);

    if (
        isFeatureEnabled('cal-board-multipleBoards-dev') &&
        isBoardViewTypeSelected() &&
        lazyHasSelectedProject.tryImportForRender()?.()
    ) {
        const projectId = lazyGetSelectedProjectId.tryImportForRender()?.();
        if (!!projectId) {
            route.push(ID_ROUTE_KEYWORD, projectId);
            return route;
        }
    }

    return route;
}
